import React from 'react';
import PropTypes from 'prop-types';
import NextUpTabSummaryTimeline from './NextUpSummaryTimeline';

// TODO: This should be a simple picker, but we need to refactor the tech debt in the parent component first
const NextUpTabContentPicker = ({ resource }) => {
  if (resource.type() === 'FacetPlanProposalScenarioNextUpSummaryTimelineWrapper') {
    return <NextUpTabSummaryTimeline resource={resource} />;
  }

  return null;
};

NextUpTabContentPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default NextUpTabContentPicker;
